export default "__VITE_ASSET__BSrjt9yo__"